import { createRequest, getEndpoint } from "../requestCreator";

export const getPublicSettings = createRequest(getEndpoint("settings.sub.internal.sub.public"), {
  public: true,
});
